import React from "react";
import "./componentWarehouse.css";
import search from "../../../../../assests/search.svg";
import Table from "react-bootstrap/Table";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Sidebar from "../../../Sidebar/Sidebar";
import leftArrow from "../../../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import LoadingSpinner from "../../../../Loading/component";

export const UpdateWarehouseComponent = (props) => {
  const navigate = useNavigate();
  const { userid } = useParams();

  const handleSaveClick = () => {
    props.UpdateUserwarehouseApi();
    navigate(-1);
    return toastr.success("Warehouse Update");
  };

  const backUpdateWarehouse = () => {
    navigate(-1);
  };

  return (
    <div className="main-div">
      <Sidebar />
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="updateWarehouseWrapper">
          {/* Header with back arrow */}
          <div className="updateWarehouseHeader">
            <img
              src={leftArrow}
              alt="Back"
              className="backArrowIcon"
              onClick={backUpdateWarehouse}
            />
            <h2>Update Warehouse</h2>
          </div>

          {/* Search bar */}
          <div className="searchBarWrapper">
            <input
              type="search"
              placeholder="Search by Warehouse Name / ID"
              onChange={(e) => props.handleSearch(e.target.value)}
              className="warehouseSearchInput"
            />
            <img className="warehouseSearchIcon" src={search} alt="Search" />
          </div>

          {/* Inner content */}
          <div className="updateWarehouseContent">
            <div className="tableContainer">
              <Table striped hover>
                <thead>
                  <tr>
                    <th>Warehouse ID</th>
                    <th>Warehouse Name</th>
                    <th>Area Name</th>
                    <th>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data &&
                    props.data.length &&
                    props.data.map((el) => (
                      <tr key={el.id}>
                        <td>{el.warehouseId}</td>
                        <td>{el.warehouseName}</td>
                        <td>{el.warehouseCity}</td>
                        <td>
                          <div className="radioWrapper">
                            <input
                              type="radio"
                              onClick={(event) =>
                                props.handleRadioChange(event, el.warehouseId)
                              }
                              name="radio-group"
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>

            {/* Save & Back Buttons */}
            <Box className="usersrolebtn">
              <Button className="backbtno" onClick={backUpdateWarehouse}>
                Back
              </Button>
              <Button
                onClick={handleSaveClick}
                disabled={!props.isRadioClicked}
                className={
                  props.isRadioClicked
                    ? "ButtonSaveWarehouse Active"
                    : "ButtonSaveWarehouse Disabled"
                }
              >
                Save
              </Button>
            </Box>
          </div>
        </div>
      )}
    </div>
  );
};
